import { Options } from 'vue-class-component';
import {
  ActuatorModalityType,
  SystemControlType,
} from '@/../client-generator/generated-clients/plants';
import ThermoGeneralStep from '../ThermoGeneralStep';

@Options({
  name: 'Step0WorkingMode',
  watch: {
    'roomObject.actuatorModalityType': function (newValue, oldValue) {
      if (oldValue != undefined) this.actuatorModalityTypeChange();
    },
  },
})
export default class Step0WorkingMode extends ThermoGeneralStep {
  get typeOptions() {
    return Object.keys(ActuatorModalityType)
      .filter(
        (value) =>
          !isNaN(Number(value)) && Number(value) != ActuatorModalityType.None
      )
      .map((value) => Number(value));
  }

  created() {
    this.nextEnabled =
      this.roomObject.actuatorModalityType !== ActuatorModalityType.None;
  }

  getOptionName(type: ActuatorModalityType) {
    return this.$t(`AppResource.${ActuatorModalityType[type]}`);
  }

  getOptionDescription(type: ActuatorModalityType) {
    return this.$t(`AppResource.${ActuatorModalityType[type]}Info`);
  }

  actuatorModalityTypeChange() {
    this.nextEnabled =
      this.roomObject.actuatorModalityType !== ActuatorModalityType.None;
    this.roomObject.heatingSystemControlType = SystemControlType.None;
    this.roomObject.coolingSystemControlType = SystemControlType.None;
    this.roomObject.sharedSystemControlType = SystemControlType.None;
  }
}
